<template>
  <v-card :elevation="0">
    <v-card-text>
      <v-row class="d-flex align-center">
        <v-col cols="12" md="5">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDate" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedDate"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                dense
                hide-details
                v-bind="attrs"
                v-on="on"
                class="d-flex justify-center"
              >
                <template v-slot:append-outer>
                  <v-btn @click="search" color="success" :disabled="!selectedDate">Search</v-btn>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="selectedDate" scrollable color="red accent-2">
              <v-spacer></v-spacer>
              <v-btn text color="red accent-2" @click="modal = false">Cancel</v-btn>
              <v-btn text color="red accent-2" @click="$refs.dialog.save(selectedDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          class="d-flex justify-center"
          color="yellow"
          :disabled="filterDisabled"
          @click="dialog = true"
        >
          <v-icon left>mdi-chevron-down</v-icon>
          <span>Filters</span>
        </v-btn>
      </v-row>
    </v-card-text>
    <v-row justify="center">
      <v-dialog content-class="mx-0 px-0" v-model="dialog" hide-overlay max-width="700px">
        <v-card>
          <v-card-title>
            <span>Filters</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedKitchens"
                  :items="kitchens"
                  item-text="id"
                  item-value="uuid"
                  chips
                  label="Kitchens"
                  multiple
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedConcepts"
                  :items="concepts"
                  item-text="label"
                  item-value="uuid"
                  chips
                  label="Concepts"
                  multiple
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedPlatforms"
                  :items="platforms"
                  item-text="label"
                  item-value="uuid"
                  chips
                  label="Platforms"
                  multiple
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedCountries"
                  :items="countries"
                  item-text="label"
                  item-value="id"
                  chips
                  label="Countries"
                  multiple
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedStatuses"
                  :items="statuses"
                  item-text="label"
                  item-value="id"
                  chips
                  label="Status"
                  multiple
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedShifts"
                  :items="shifts"
                  item-text="label"
                  item-value="id"
                  chips
                  label="Shift"
                  multiple
                  solo
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="dialog = false">close</v-btn>
            <v-btn @click="apply" color="success">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    filterDisabled: { type: Boolean },
    kitchens: { type: Array },
    concepts: { type: Array },
    platforms: { type: Array },
    countries: { type: Array },
    orders: { type: Array },
  },
  data: () => {
    return {
      selectedDate: null,
      modal: false,
      dialog: false,
      selectedKitchens: [],
      selectedConcepts: [],
      selectedPlatforms: [],
      selectedCountries: [],
      selectedStatuses: [],
      selectedShifts: [],
    };
  },
  computed: {
    statuses() {
      let statuses = Object.keys(
        _.chain(this.orders).groupBy("status").value()
      );
      let res = [];
      for (let index in statuses) {
        res.push({
          label: this.statusMapping(statuses[index]),
          id: statuses[index],
        });
      }
      return res;
    },
    shifts() {
      let shifts = Object.keys(_.chain(this.orders).groupBy("shift").value());
      let res = [];
      for (let index in shifts) {
        res.push({
          label: this.shiftMapping(shifts[index]),
          id: shifts[index],
        });
      }
      return shifts;
    },
  },
  methods: {
    search() {
      this.$emit("search", this.selectedDate);
    },
    apply() {
      this.$emit(
        "apply",
        this.selectedKitchens,
        this.selectedConcepts,
        this.selectedPlatforms,
        this.selectedCountries,
        this.selectedStatuses,
        this.selectedShifts
      );
      this.dialog = false;
    },
    statusMapping(status) {
      let offStatus = {
        accepted: "Accepted",
        cancelled: "Cancelled",
        created: "Created",
        remade_platform: "Remade (platform)",
        remade_restaurant: "Remade (restaurant)",
        rejected: "Rejected",
        delivered: "Delivered",
      };
      return offStatus[status];
    },

    shiftMapping(shift) {
      let offShift = {
        lunch: "Lunch",
        dinner: "Dinner",
        unknown: "Unknown",
      };
      return offShift[shift];
    },
  },
};
</script>
